export function isVehicleLookupNotFoundError(error: unknown): boolean {
  const status =
    typeof error === 'object' && error && 'status' in error
      ? Number((error as { status?: number }).status)
      : undefined

  if (status === 404) return true

  const message = error instanceof Error ? error.message : String(error ?? '')
  const lower = message.toLowerCase()

  return (
    lower.includes('not found') ||
    lower.includes('nosuchkey') ||
    lower.includes('no such key') ||
    lower.includes('(http 404)')
  )
}
